<div class="wrapper">
    <v-card>
        <v-card-title class="mb-2">
            <v-row>
                <v-col cols="3" class="d-flex align-center">
                    Monthly report preview
                </v-col>
                <v-col cols="9" class="d-flex align-center">
                    <v-row>
                        <v-spacer></v-spacer>
                        <MonthlyReportDialog
                            v-model:visible="englishDialogVisible"
                            buttonSignature="Edit English part"
                            header="Email content"
                            :mainContent="englishContent"
                            :templateSignature="englishSignature"
                            @save="saveEnglishContent" />
                        <MonthlyReportDialog
                            class="pr-2"
                            v-model:visible="germanDialogVisible"
                            buttonSignature="Edit German part"
                            header="Email content"
                            :mainContent="germanContent"
                            :templateSignature="germanSignature"
                            @save="saveGermanContent" />
                    </v-row>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text>
            <MonthlyReportContent
                :germanContent="germanContent"
                :germanSignature="germanSignature"
                :englishContent="englishContent"
                :englishSignature="englishSignature" />
        </v-card-text>
    </v-card>
</div>